import { ObjectModel } from 'objectmodel';

const SimpleResult = new ObjectModel({
  id: String,
  success: Boolean,
  detail: [Object]
});

export { SimpleResult };
